import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";

import { ToastService } from "./toast.service";
import { ToastState } from "./toast";

const AUTO_HIDE_DELAY_MS = 3000;

@Component({
    selector: "bo-toast",
    templateUrl: "./toast.component.html",
    styleUrls: ["./toast.component.scss"]
})

export class ToastComponent implements OnInit, OnDestroy {

    show = false;
    success = true;
    message = "";

    private subscription: Subscription = new Subscription();
    private hideTimeout: any;

    constructor(
        private toastService: ToastService
    ) { }

    ngOnInit(): void {
        this.subscription = this.toastService.toastState
            .subscribe((state: ToastState) => {
                this.success = state.success;
                this.message = state.message;
                this.show = state.show;

                clearTimeout(this.hideTimeout);
                this.hideTimeout = setTimeout(() => {
                    this.show = false;
                }, AUTO_HIDE_DELAY_MS);
            });
    }

    close(): void {
        clearTimeout(this.hideTimeout);
        this.show = false;
    }

    ngOnDestroy(): void {
        clearTimeout(this.hideTimeout);
        this.subscription.unsubscribe();
    }
}
